import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';


const Footer = () => {

    return(
  <Box
    component="section"
    id="footer "
    sx={{ bgcolor: "#0d1117", borderTop: "1px solid rgba(255, 0, 51, 0.2)", py: 4 }}
  >
  <Container
      maxWidth="lg"
    >
      <Box
        sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "space-between", alignItems: "center", gap: 2 }}
      >
        <Typography
          sx={{ fontFamily: "JetBrains Mono, monospace", fontSize: "14px", color: "#8b949e", textAlign: { xs: "center", md: "left" } }}
        >
          Made with passion & hunger to strike
        </Typography>
        <Typography
          sx={{ fontFamily: "JetBrains Mono, monospace", fontSize: "14px", color: "#8b949e", textAlign: { xs: "center", md: "right" } }}
        >
          © 2025 Nicholas M. Njama. All rights reserved.
        </Typography>
      </Box>
    </Container>
     </Box>
    );
  };

  export default Footer;